module.exports = __webpack_public_path__ + "static/media/subtract 2.de380680.webp";